import { LiveEventScreen } from '@/screens/name-screen/LiveEventScreen'

export default function () {
  return <LiveEventScreen />
}
